import React from 'react';

import FormRow from 'components/FormRow';
import LoanDescription from 'modules/Inquiry/Form/Steps/RequestDetails/ProductKindDetails/Loan/LoanTypeFields/sections/overlappingFields/LoanDescription';
import LoanInterestPeriodInMonths from 'modules/Inquiry/Form/Steps/RequestDetails/ProductKindDetails/Loan/LoanTypeFields/sections/overlappingFields/LoanInterestPeriodInMonths/LoanInterestPeriodInMonths';

const AnnuityLoan = () => (
  <>
    <FormRow separator>
      <LoanInterestPeriodInMonths />
    </FormRow>

    <FormRow>
      <LoanDescription />
    </FormRow>
  </>
);

export default AnnuityLoan;
